import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { Header, Container, Row, Column, Box, Icons, Line, Text, Button } from '@generationtux/component-library';
import { scrollTop } from '../utils/utils';

const WelcomePage = () => {
  const { push } = useHistory();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
      });
    }, 0);
  });

  return (
    <Container mt={4}>
      <Row flexWrap alignItems="center">
        <Column columnSm={0} columnLg={1} />
        <Column columnSm={6} columnLg={5}>
          <Box shadowLevel={3} polaroid py={4} pl={3} backgroundColor="grayLighter">
            <img
              style={{ display: 'block' }}
              src="https://gentux.imgix.net/1568660940_home-hero.jpg"
              alt="hero box shot"
            />
          </Box>
        </Column>
        <Column columnSm={1} columnLg={1} />
        <Column columnSm={5} columnLg={3} mt={4} mb={5}>
          <Icons.LogoGentux mb={3} />
          <Header type={1} size={4} textColor="grayDark">
            Generation Tux
          </Header>
          <Header type={1} size={2} headline>
            The perfect suit or tux. Delivered.
          </Header>
          <Line headlineDivider />
          <Text mb={3}>
            Suit rentals straight to your door. Including free shipping, free replacements and world-class service.
          </Text>

          <Header type={1} size={5} mb={1}>
            Test Look Builder - 2020-06-05
          </Header>

          <Text mb={3}>The following is a test for our look building user interface.</Text>

          <Button
            px={[5, 5, 5, 5, 6, 6]}
            buttonType="info"
            onClick={() => {
              scrollTop();
              push('/look-build');
            }}
          >
            Build A Look <Icons.ArrowRight ml={2} />
          </Button>
        </Column>
      </Row>
    </Container>
  );
};

export default WelcomePage;
